var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoOutlineIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  stroke: "inherit",
  viewBox: "0 0 38 38"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 26,
  x: 6,
  y: 6,
  strokeWidth: 2,
  opacity: 0.3,
  rx: 13
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  x: 1,
  y: 1,
  strokeWidth: 2,
  opacity: 0.1,
  rx: 18
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#info-outline-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  d: "M19 22.333v-3.334m0-3.333h.008m8.325 3.333a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "info-outline-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9 9h20v20H9z"
})))));
export { SvgInfoOutlineIcon as ReactComponent };
export default __webpack_public_path__ + "e79aae6adfe43805c3719810f499b2cb.svg";